"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createSocialEditDialog = createSocialEditDialog;
var _dialog = require("../../ui/dialog");
var _litHtml = require("lit-html");
require("solid-ui/components/actions/button");
require("solid-ui/components/forms/select");
require("../contactInfo/ContactInfoEditDialog.css");
require("../../styles/EditDialogs.css");
var _rowState = require("../shared/rowState");
var _textUtils = require("../../textUtils");
var _mutations = require("./mutations");
var _profileIcons = require("../../icons-svg/profileIcons");
var _texts = require("../../texts");
var _constants = require("./constants");
var _helpers = require("./helpers");
/* The code below for handling reordering were generated by AI Model: GPT-5.3-Codex. */
/* Prompt: can you implement on SocialEditDialog add the bentoIcon as the first item 
on the row, you should be able to drag this button around and it should allow you 
to change the order of the rows and that should change the order in the mutations 
that happen for this data. */

function toSocialAccountSelectOptions(options) {
  return options.map(option => ({
    label: option.label,
    value: option.label
  }));
}
function getSocialAccountSelectValue(row, options) {
  const selected = (0, _helpers.findSocialAccountOption)(options, row?.name || '');
  return selected?.label || '';
}
function readSocialAccountTypeChange(event) {
  const customEvent = event;
  if (typeof customEvent.detail?.value === 'string') {
    return customEvent.detail.value;
  }
  const target = event.target;
  return typeof target?.value === 'string' ? target.value : '';
}
function initializeSocialAccountSelects(form, rows, options) {
  const selectOptions = toSocialAccountSelectOptions(options);
  const selectElements = form.querySelectorAll('solid-ui-select[data-social-account-row-index]');
  selectElements.forEach(selectElement => {
    const rowIndex = Number(selectElement.dataset.socialAccountRowIndex);
    if (Number.isNaN(rowIndex)) return;
    const row = rows[rowIndex];
    if (!row) return;
    selectElement.options = selectOptions;
    selectElement.value = getSocialAccountSelectValue(row, options);
    selectElement.label = '';
  });
}
function focusSocialField(form, selector) {
  const nextField = form.querySelector(selector);
  if (!nextField) return;
  if (typeof nextField.scrollIntoView === 'function') {
    nextField.scrollIntoView({
      block: 'start',
      behavior: 'auto'
    });
  }
  const view = form.ownerDocument.defaultView;
  const shouldAvoidFocus = Boolean(view?.matchMedia && (view.matchMedia('(pointer: coarse)').matches || view.matchMedia('(max-width: 640px)').matches));
  if (shouldAvoidFocus) return;
  if (nextField.tagName === 'SOLID-UI-SELECT') {
    const triggerButton = nextField.shadowRoot?.querySelector('button');
    triggerButton?.focus();
    return;
  }
  if (typeof nextField.focus === 'function') {
    nextField.focus();
  }
}
function sanitizeSocialFieldValue(value) {
  return (0, _textUtils.sanitizeTextValue)(value);
}
function sanitizeUrlFieldValue(value) {
  return (0, _textUtils.sanitizeTextValue)(value).replace(/\s+/g, '');
}
function rowHasContent(row) {
  // A social account is considered meaningful only when a personal profile URL is set.
  return (0, _textUtils.hasNonEmptyText)(row.homepage);
}
function toFormState(socialAccounts) {
  const rows = (socialAccounts || []).map(account => ({
    name: sanitizeSocialFieldValue((0, _textUtils.toText)(account.name)),
    icon: sanitizeSocialFieldValue((0, _textUtils.toText)(account.icon)),
    homepage: sanitizeSocialFieldValue((0, _textUtils.toText)(account.homepage)),
    entryNode: (0, _textUtils.toText)(account.entryNode),
    status: (0, _textUtils.toText)(account.entryNode) ? 'existing' : 'new'
  })).filter(row => Boolean(row.name || row.icon || row.homepage || row.entryNode));
  return {
    socialAccounts: rows.length ? rows : [{
      name: '',
      icon: '',
      homepage: '',
      entryNode: '',
      status: 'new'
    }],
    initialExistingOrder: []
  };
}
function hasOrderChanged(rows, initialExistingOrder) {
  const currentExistingOrder = rows.filter(row => row.status !== 'deleted' && Boolean((row.entryNode || '').trim())).map(row => (row.entryNode || '').trim());
  if (currentExistingOrder.length !== initialExistingOrder.length) return true;
  for (let i = 0; i < currentExistingOrder.length; i++) {
    if (currentExistingOrder[i] !== initialExistingOrder[i]) return true;
  }
  return false;
}
function validateSocialBeforeSave(rows) {
  for (let i = 0; i < rows.length; i++) {
    const row = rows[i];
    if (!row || row.status === 'deleted') continue;
    const hasAnyValue = [row.name, row.icon, row.homepage].some(_textUtils.hasNonEmptyText);
    if (!hasAnyValue) continue;
    if (!(0, _textUtils.hasNonEmptyText)(row.name) || !(0, _textUtils.hasNonEmptyText)(row.icon)) {
      return `Social account ${i + 1}: please choose an account type from the dropdown.`;
    }
    if (!(0, _textUtils.hasNonEmptyText)(row.homepage)) {
      return `Social account ${i + 1}: please enter your personal profile link.`;
    }
  }
  return null;
}
function renderSocialAccountInputSelect(row, rowIndex, options, onChange) {
  const selectedLabel = getSocialAccountSelectValue(row, options);
  return (0, _litHtml.html)`
    <solid-ui-select
      class="profile-edit-dialog__social-account-select"
      name=${`social-account-type-${rowIndex}`}
      data-social-account-row-index=${String(rowIndex)}
      autocomplete="off"
      .options=${toSocialAccountSelectOptions(options)}
      .value=${selectedLabel}
      .label=${''}
      @change=${onChange}
    ></solid-ui-select>
  `;
}
function renderSocialInputRow({
  rows,
  index,
  displayIndex,
  onDelete,
  onChange,
  options,
  onDragStart,
  onDragEnter,
  onDragOver,
  onDrop,
  onDragEnd,
  onPointerDown,
  onPointerMove,
  onPointerUp,
  onPointerCancel,
  isDropTarget
}) {
  const row = rows[index];
  const nameLabel = `Social Account Name ${displayIndex + 1}`;
  const homepageLabel = `Social Account Homepage ${displayIndex + 1}`;
  const handleTextInput = field => event => {
    const target = event.target;
    const nextValue = field === 'homepage' ? sanitizeUrlFieldValue(target.value) : sanitizeSocialFieldValue(target.value);
    if (rows[index]) {
      (0, _rowState.applyRowFieldChange)(rows[index], field, nextValue, rowHasContent);
      onChange();
    }
  };
  const handleAccountTypeInput = event => {
    const selected = (0, _helpers.findSocialAccountOption)(options, readSocialAccountTypeChange(event));
    if (!rows[index]) return;
    if (!selected) {
      (0, _rowState.applyRowFieldChange)(rows[index], 'name', '', rowHasContent);
      (0, _rowState.applyRowFieldChange)(rows[index], 'icon', '', rowHasContent);
      onChange();
      return;
    }
    (0, _rowState.applyRowFieldChange)(rows[index], 'name', selected.label, rowHasContent);
    (0, _rowState.applyRowFieldChange)(rows[index], 'icon', selected.icon || _constants.DEFAULT_ICON_URI, rowHasContent);
    onChange();
  };
  const handleDelete = event => {
    event.preventDefault();
    onDelete();
  };
  return (0, _litHtml.html)`
    <div
      class="profile-edit-dialog__row profile-edit-dialog__row--social ${isDropTarget ? 'profile-edit-dialog__row--drop-target' : ''}"
      data-social-reorder-index=${String(index)}
      @dragenter=${() => onDragEnter(index)}
      @dragover=${event => onDragOver(event, index)}
      @drop=${event => onDrop(event, index)}
    >
      <solid-ui-button
        type="button"
        class="profile-edit-dialog__drag-handle"
        variant="icon"
        size="md"
        aria-label=${`Reorder social account ${displayIndex + 1}`}
        title="Drag to reorder"
        draggable="true"
        @dragstart=${event => onDragStart(event, index)}
        @dragend=${() => onDragEnd()}
        @pointerdown=${event => onPointerDown(event, index)}
        @pointermove=${event => onPointerMove(event)}
        @pointerup=${event => onPointerUp(event)}
        @pointercancel=${event => onPointerCancel(event)}
      >
        <span slot="icon" class="profile-edit-dialog__drag-handle-icon" aria-hidden="true">${_profileIcons.bentoIcon}</span>
      </solid-ui-button>
      <img 
        class="profile-edit-dialog__social-icon" 
        src="${row?.icon || _constants.DEFAULT_ICON_URI}" 
        alt="${row?.name || 'Social'} icon"
        width="30"
        height="30"
        loading="lazy"
      />
      <label aria-label=${nameLabel} class="label profile-edit-dialog__field profile-edit-dialog__field--social-type">
        ${renderSocialAccountInputSelect(row, index, options, handleAccountTypeInput)}
      </label>
      <label aria-label=${homepageLabel} class="label profile-edit-dialog__field profile-edit-dialog__field--social-url">
        <input
          class="input"
          type="text"
          name=${`social-homepage-${index}`}
          .value=${row?.homepage || ''}
          data-contact-field="homepage"
          data-entry-node=${row?.entryNode || ''}
          data-row-status=${row?.status || 'n/a'}
          placeholder="Profile link or handle"
          autocomplete="off"
          inputmode="text"
          required
          @input=${handleTextInput('homepage')}
        />
          <small class="profile-edit-dialog__input-help-text">Enter your profile link, handle, or username.</small>
      </label>
      <div class="profile-edit-dialog__actions profile-edit-dialog__actions--edge">
        <solid-ui-button
          type="button"
          variant="icon"
          size="md"
          class="profile-edit-dialog__delete-button"
          aria-label=${`Delete social account ${displayIndex + 1}`}
          title=${_texts.deleteEntryButtonTitleText}
          @click=${handleDelete}
        >
          <span slot="icon" class="profile-edit-dialog__delete-icon" aria-hidden="true">${_profileIcons.trashIcon}</span>
        </solid-ui-button>
      </div>
    </div>
  `;
}
function renderSocialSection(rows, options, onRerender) {
  let dragSourceIndex = null;
  let dropTargetIndex = null;
  let touchPointerId = null;
  const reorderRows = (from, to) => {
    if (from === to) return;
    const row = rows[from];
    if (!row) return;
    rows.splice(from, 1);
    rows.splice(to, 0, row);
  };
  const handleDragStart = (event, index) => {
    dragSourceIndex = index;
    dropTargetIndex = index;
    if (event.dataTransfer) {
      event.dataTransfer.effectAllowed = 'move';
      event.dataTransfer.setData('text/plain', String(index));
    }
  };
  const handleDragEnter = index => {
    if (dragSourceIndex === null) return;
    dropTargetIndex = index;
  };
  const handleDragOver = (event, index) => {
    event.preventDefault();
    if (dragSourceIndex !== null) {
      dropTargetIndex = index;
    }
    if (event.dataTransfer) {
      event.dataTransfer.dropEffect = 'move';
    }
  };
  const handleDrop = (event, index) => {
    event.preventDefault();
    const transferIndex = event.dataTransfer?.getData('text/plain');
    const sourceIndex = dragSourceIndex ?? (transferIndex ? Number(transferIndex) : null);
    if (sourceIndex === null || Number.isNaN(sourceIndex)) return;
    reorderRows(sourceIndex, index);
    dragSourceIndex = null;
    dropTargetIndex = null;
    onRerender();
  };
  const handleDragEnd = () => {
    dragSourceIndex = null;
    dropTargetIndex = null;
  };
  const updateTouchDropTarget = event => {
    const dom = event.currentTarget?.ownerDocument || document;
    const target = dom.elementFromPoint(event.clientX, event.clientY)?.closest('[data-social-reorder-index]');
    if (!target) return;
    const nextIndex = Number(target.dataset.socialReorderIndex);
    if (!Number.isNaN(nextIndex)) {
      dropTargetIndex = nextIndex;
    }
  };
  const handlePointerDown = (event, index) => {
    if (event.pointerType !== 'touch') return;
    event.preventDefault();
    dragSourceIndex = index;
    dropTargetIndex = index;
    touchPointerId = event.pointerId;
    event.currentTarget?.setPointerCapture?.(event.pointerId);
  };
  const handlePointerMove = event => {
    if (event.pointerType !== 'touch' || touchPointerId !== event.pointerId || dragSourceIndex === null) return;
    event.preventDefault();
    updateTouchDropTarget(event);
  };
  const handlePointerUp = event => {
    if (event.pointerType !== 'touch' || touchPointerId !== event.pointerId) return;
    event.preventDefault();
    updateTouchDropTarget(event);
    const sourceIndex = dragSourceIndex;
    const targetIndex = dropTargetIndex;
    event.currentTarget?.releasePointerCapture?.(event.pointerId);
    touchPointerId = null;
    dragSourceIndex = null;
    dropTargetIndex = null;
    if (sourceIndex === null || targetIndex === null || sourceIndex === targetIndex) return;
    reorderRows(sourceIndex, targetIndex);
    onRerender();
  };
  const handlePointerCancel = event => {
    if (event.pointerType !== 'touch' || touchPointerId !== event.pointerId) return;
    event.currentTarget?.releasePointerCapture?.(event.pointerId);
    touchPointerId = null;
    dragSourceIndex = null;
    dropTargetIndex = null;
  };
  const visibleRows = rows.map((row, index) => ({
    row,
    index
  })).filter(({
    row
  }) => row.status !== 'deleted');
  return (0, _litHtml.html)`
    <section class="profile-edit-dialog__section" aria-label="Social Accounts">
      <fieldset>
        <legend class="sr-only">Social account entries</legend>
        ${visibleRows.map(({
    index
  }, displayIndex) => renderSocialInputRow({
    rows,
    index,
    displayIndex,
    onDelete: () => {
      (0, _rowState.deleteRow)(rows, index);
      onRerender();
    },
    onChange: onRerender,
    options,
    onDragStart: handleDragStart,
    onDragEnter: handleDragEnter,
    onDragOver: handleDragOver,
    onDrop: handleDrop,
    onDragEnd: handleDragEnd,
    onPointerDown: handlePointerDown,
    onPointerMove: handlePointerMove,
    onPointerUp: handlePointerUp,
    onPointerCancel: handlePointerCancel,
    isDropTarget: dropTargetIndex === index
  }))}
      </fieldset>
    </section>
  `;
}
function renderSocialEditTemplate(form, formState, store, viewerMode, rerenderOptions = {}) {
  const rerender = (nextOptions = {}) => renderSocialEditTemplate(form, formState, store, viewerMode, nextOptions);
  const socialOptions = (0, _helpers.getSocialAccountOptions)(store);
  (0, _litHtml.render)((0, _litHtml.html)`
    ${renderSocialSection(formState.socialAccounts, socialOptions, rerender)}
    ${viewerMode !== 'owner' ? (0, _litHtml.html)`<p class="profile-edit-dialog__login-message">${_texts.ownerLoginRequiredDialogMessageText}</p>` : null}
  `, form);
  initializeSocialAccountSelects(form, formState.socialAccounts, socialOptions);
  if (rerenderOptions.focusSelector) {
    focusSocialField(form, rerenderOptions.focusSelector);
  }
}
function createSocialEditForm(details, store, viewerMode) {
  const form = document.createElement('form');
  form.classList.add('profile__edit-form');
  const formState = toFormState(details);
  formState.initialExistingOrder = formState.socialAccounts.filter(row => Boolean((row.entryNode || '').trim())).map(row => (row.entryNode || '').trim());
  renderSocialEditTemplate(form, formState, store, viewerMode);
  const addRow = () => {
    formState.socialAccounts.unshift({
      name: '',
      icon: '',
      homepage: '',
      entryNode: '',
      status: 'new'
    });
    renderSocialEditTemplate(form, formState, store, viewerMode, {
      focusSelector: '[name="social-account-type-0"]'
    });
  };
  return {
    form,
    formState,
    addRow
  };
}
async function createSocialEditDialog(event, store, subject, socialAccounts, viewerMode, onSaved) {
  const dom = event.currentTarget?.ownerDocument || document;
  const {
    form,
    formState,
    addRow
  } = createSocialEditForm(socialAccounts, store, viewerMode);
  const result = await (0, _dialog.openInputDialog)({
    title: _texts.editSocialDialogTitleText,
    dom,
    form,
    onOpen: () => focusSocialField(form, '[name="social-account-type-0"]'),
    shouldCloseWithoutSave: () => {
      const ops = (0, _rowState.summarizeRowOps)(formState.socialAccounts, rowHasContent);
      const orderChanged = hasOrderChanged(formState.socialAccounts, formState.initialExistingOrder);
      return ops.create.length === 0 && ops.update.length === 0 && ops.remove.length === 0 && !orderChanged;
    },
    headerAction: {
      type: 'button',
      label: '+ Add More',
      ariaLabel: 'Add another social account',
      onClick: addRow
    },
    submitLabel: _texts.dialogSubmitLabelText,
    cancelLabel: _texts.dialogCancelLabelText,
    validate: () => {
      if (viewerMode !== 'owner') {
        return _texts.ownerLoginRequiredDialogMessageText;
      }
      return validateSocialBeforeSave(formState.socialAccounts);
    },
    onSave: async () => {
      const socialOps = (0, _rowState.summarizeRowOps)(formState.socialAccounts, rowHasContent);
      const plan = {
        create: socialOps.create,
        update: socialOps.update,
        remove: socialOps.remove
      };
      await (0, _mutations.processSocialMutations)(store, subject, plan, formState.socialAccounts);
    },
    formatSaveError: error => {
      return error instanceof Error ? error.message : _texts.saveSocialUpdatesFailedMessageText;
    }
  });
  if (!result) return;
  if (onSaved) {
    await onSaved();
  }
}